import { AllocationViewListDateRangeFilter } from '../allocation-view/models/allocation-view-filters.model';
import { AutomotiveAftermarketDateRangeFilter } from '../automotive-aftermarket/models/automotive-aftermarket-list-filters.model';
import { AllocationViewCollectionBasedFilter, AllocationViewLabelBasedFilter } from '../allocation-view/constants';
import { TransportManagementTimeFilter } from '../transport-management/models';
import { ShipmentTimeFilter } from '../models/shipment-common-models';

export enum AddressManagementDateRangeFilters {
  CreationDate = 'creationDate',
}

export enum FailedMessagesDateRangeFilters {
  TransactionDateTime = 'transactionDateTime',
}

export const MonitoringDateRangeFilter = {
  ...AutomotiveAftermarketDateRangeFilter,
  ...TransportManagementTimeFilter,
  ...ShipmentTimeFilter,
  ...AddressManagementDateRangeFilters,
  ...FailedMessagesDateRangeFilters,
};

export type MonitoringDateRangeFilter = AutomotiveAftermarketDateRangeFilter & TransportManagementTimeFilter;

export const MonitoringLabelBasedFilter = {
  ...AllocationViewLabelBasedFilter,
};

export const MonitoringValueBasedTimeRangeFilter = {
  ...AllocationViewListDateRangeFilter,
};

export const MonitoringCollectionBasedFilter = {
  ...AllocationViewCollectionBasedFilter,
};

export type MonitoringLabelBasedFilter = AllocationViewLabelBasedFilter;

export type MonitoringCollectionBasedFilter = AllocationViewCollectionBasedFilter;

export enum MonitoringCountryFilters {
  DestinationCountries = 'destinationCountries',
  SourceCountries = 'sourceCountries',
  PortOfLoadingCountries = 'portsOfLoadingCountries',
  PortOfDischargeCountries = 'portsOfDischargeCountries',
}
